import { cn } from '@today/ui-primitives'

/** One step of the designer. */
export interface DesignerStepItem {
	id: string
	label: string
	/** A step that cannot be opened yet (e.g. preview before a sample). */
	disabled?: boolean
}

/**
 * Props for {@link ImportDesignerStepper}.
 *
 * @property steps - The steps, in order.
 * @property current - The open step's id.
 * @property onSelect - Called with the id of the step to open.
 */
export interface ImportDesignerStepperProps {
	steps: readonly DesignerStepItem[]
	current: string
	onSelect: (id: string) => void
}

/** The designer's step navigation (TO-400 Happy path): any enabled step can be opened. Pure. */
export function ImportDesignerStepper({ steps, current, onSelect }: ImportDesignerStepperProps) {
	return (
		<nav aria-label="Designer steps">
			<ol className="flex flex-wrap gap-2 text-ds-sm">
				{steps.map((step, i) => (
					<li key={step.id}>
						<button
							type="button"
							disabled={step.disabled}
							aria-current={step.id === current ? 'step' : undefined}
							onClick={() => onSelect(step.id)}
							className={cn(
								'rounded-ds-control border border-ds-border px-3 py-1 text-ds-text disabled:opacity-50',
								step.id === current && 'bg-ds-primary text-ds-on-primary',
							)}
						>
							{i + 1}. {step.label}
						</button>
					</li>
				))}
			</ol>
		</nav>
	)
}
